(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-announcement-rotator]').forEach(function (rot) {
      var slides = rot.querySelectorAll('.announcement-bar__slide');
      if (slides.length < 2) return;

      var i = 0;
      var wait = (parseFloat(rot.dataset.interval) || 4) * 1000;

      /* la visibilita' si imposta inline: cosi non dipende dal CSS della sezione,
         che potrebbe essere in cache vecchia subito dopo una pubblicazione */
      function show(el, visible) {
        el.style.opacity = visible ? '1' : '0';
        el.style.pointerEvents = visible ? 'auto' : 'none';
        if (visible) { el.classList.add('is-active'); el.removeAttribute('aria-hidden'); }
        else { el.classList.remove('is-active'); el.setAttribute('aria-hidden', 'true'); }
      }

      for (var s = 1; s < slides.length; s++) {
        slides[s].style.position = 'absolute';
        slides[s].style.top = slides[s].style.right = slides[s].style.bottom = slides[s].style.left = '0';
        show(slides[s], false);
      }
      show(slides[0], true);

      setInterval(function () {
        show(slides[i], false);
        i = (i + 1) % slides.length;
        show(slides[i], true);
      }, wait);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function() {
    var form = document.querySelector('.cart-page__form');
    if (!form) return;

    /* Debounced submit so quantity changes are always persisted,
       even if the customer leaves without clicking checkout */
    var submitTimer = null;
    function scheduleUpdate() {
      clearTimeout(submitTimer);
      submitTimer = setTimeout(function() {
        /* Submit updates[] to /cart (not checkout) and reload the cart */
        if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); }
      }, 800);
    }

    document.querySelectorAll('[data-qty-plus]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var input = document.querySelector('[data-qty-input="' + btn.dataset.qtyPlus + '"]');
        input.value = (parseInt(input.value) || 0) + 1;
        scheduleUpdate();
      });
    });
    document.querySelectorAll('[data-qty-minus]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var input = document.querySelector('[data-qty-input="' + btn.dataset.qtyMinus + '"]');
        input.value = Math.max(0, (parseInt(input.value) || 0) - 1);
        scheduleUpdate();
      });
    });
    document.querySelectorAll('[data-qty-input]').forEach(function(input) {
      input.addEventListener('change', scheduleUpdate);
    });

    /* === SHIPPING ESTIMATOR === */
    var est = document.querySelector('[data-ship-est]');
    if (est) {
      var toggle = est.querySelector('[data-ship-toggle]');
      var panel = est.querySelector('.ship-est__panel');
      var calcBtn = est.querySelector('[data-ship-calc]');
      var results = est.querySelector('[data-ship-results]');
      var countryEl = est.querySelector('[data-ship-country]');
      var provinceEl = est.querySelector('[data-ship-province]');
      var zipEl = est.querySelector('[data-ship-zip]');
      var cartUrl = (window.routes && window.routes.cart_url) || '/cart';

      var esc = window.CN.esc;
      function fmt(p) { return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(parseFloat(p) || 0); }
      function err() { results.innerHTML = '<p class="ship-est__error">Impossibile calcolare la spedizione. Verifica i dati.</p>'; }

      if (toggle) toggle.addEventListener('click', function() { panel.hidden = !panel.hidden; });

      if (calcBtn) calcBtn.addEventListener('click', function() {
        results.textContent = '…';
        var params = 'shipping_address[country]=' + encodeURIComponent(countryEl.value) +
          '&shipping_address[province]=' + encodeURIComponent(provinceEl.value) +
          '&shipping_address[zip]=' + encodeURIComponent(zipEl.value);
        fetch(cartUrl + '/prepare_shipping_rates.json', {
          method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: params
        }).then(function() { poll(0); }).catch(err);

        function poll(tries) {
          fetch(cartUrl + '/async_shipping_rates.json')
            .then(function(r) { return r.json(); })
            .then(function(data) {
              if (data === null) {
                if (tries < 20) { setTimeout(function() { poll(tries + 1); }, 500); } else { err(); }
                return;
              }
              render(data.shipping_rates || []);
            }).catch(err);
        }
        function render(rates) {
          if (!rates.length) {
            results.innerHTML = '<p class="ship-est__error">Nessuna spedizione disponibile per questa destinazione.</p>';
            return;
          }
          var html = '<ul>';
          rates.forEach(function(rate) {
            html += '<li><span>' + esc(rate.presentment_name || rate.name) + '</span><span>' + fmt(rate.price) + '</span></li>';
          });
          results.innerHTML = html + '</ul>';
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-carousel"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.collection-carousel__track').forEach(function(track) {
      var id = track.id.replace('cc-track-', '');
      var progress = document.getElementById('cc-progress-' + id);
      var prevBtn = document.querySelector('[data-cc-prev="' + id + '"]');
      var nextBtn = document.querySelector('[data-cc-next="' + id + '"]');

      function updateProgress() {
        if (!progress) return;
        var max = track.scrollWidth - track.clientWidth;
        if (max <= 0) {
          progress.style.width = '100%';
          return;
        }
        var pct = (track.scrollLeft / max) * 100;
        progress.style.width = pct + '%';
      }

      function scrollBy(dir) {
        var card = track.querySelector('.collection-carousel__card');
        if (!card) return;
        track.scrollBy({ left: dir * (card.offsetWidth + 16), behavior: 'smooth' });
      }

      if (prevBtn) prevBtn.addEventListener('click', function() { scrollBy(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function() { scrollBy(1); });
      track.addEventListener('scroll', updateProgress, { passive: true });

      updateProgress();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function() {
    var trigger = document.getElementById('filter-trigger');
    var sidebar = document.getElementById('coll-sidebar');
    var overlay = document.getElementById('filters-overlay');
    var closeBtn = document.getElementById('filter-close');

    if (!trigger || !sidebar) return;

    function openFilters() {
      sidebar.classList.add('is-open');
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function closeFilters() {
      sidebar.classList.remove('is-open');
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    var sortTrigger = document.getElementById('sort-trigger');
    var sortSheet = document.getElementById('sort-sheet');
    var sortOverlay = document.getElementById('sort-overlay');
    var sortClose = document.getElementById('sort-close');

    function openSort() {
      sortSheet.classList.add('is-open');
      sortOverlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function closeSort() {
      sortSheet.classList.remove('is-open');
      sortOverlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    if (sortTrigger) sortTrigger.addEventListener('click', openSort);
    if (sortClose) sortClose.addEventListener('click', closeSort);
    if (sortOverlay) sortOverlay.addEventListener('click', closeSort);

    trigger.addEventListener('click', openFilters);
    closeBtn.addEventListener('click', closeFilters);
    overlay.addEventListener('click', closeFilters);

    /* No JS needed for mobile bar - pure CSS sticky */

    /* Toggle filter groups */
    document.querySelectorAll('[data-filter-toggle]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var group = btn.closest('.coll__filter-group');
        if (!group) return;
        var open = group.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    /* FAQ accordion (in fondo alla collezione) */
    document.querySelectorAll('[data-faq-toggle]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var item = btn.closest('.coll__faq-item');
        if (!item) return;
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    /* Search within a filter group (for long lists like Produttore) */
    document.querySelectorAll('[data-filter-search]').forEach(function(input) {
      input.addEventListener('input', function() {
        var q = input.value.trim().toLowerCase();
        var content = input.closest('.coll__filter-group-content');
        var list = content ? content.querySelector('.coll__filter-list') : null;
        if (!list) return;
        list.querySelectorAll('li').forEach(function(li) {
          var label = (li.textContent || '').toLowerCase();
          li.classList.toggle('is-hidden', q !== '' && label.indexOf(q) === -1);
        });
      });
      /* Don't submit the filter form when pressing Enter in the search box */
      input.addEventListener('keydown', function(e) { if (e.key === 'Enter') e.preventDefault(); });
    });

    /* Change sort while preserving active filters */
    function applySort(sortValue) {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sortValue);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    }
    var sortSelect = document.getElementById('sort-desktop-select');
    if (sortSelect) {
      sortSelect.addEventListener('change', function() { applySort(this.value); });
    }
    document.querySelectorAll('[data-sort-value]').forEach(function(link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        applySort(link.dataset.sortValue);
      });
    });

    /* Build URL with selected filters, keeping current sort, and navigate */
    var form = document.getElementById('filter-form');
    function applyFilters() {
      var params = [];
      new FormData(form).forEach(function(value, key) {
        if (value) params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
      });
      var currentSort = new URL(window.location.href).searchParams.get('sort_by');
      if (currentSort) params.push('sort_by=' + encodeURIComponent(currentSort));
      window.location.href = window.location.pathname + (params.length ? '?' + params.join('&') : '');
    }
    if (form) {
      /* Mobile: bottone "Applica filtri" */
      form.addEventListener('submit', function(e) { e.preventDefault(); applyFilters(); });
      /* Desktop: filtri istantanei al cambio (no bottone applica) */
      var mqDesktop = window.matchMedia('(min-width: 768px)');
      form.addEventListener('change', function(e) {
        if (!mqDesktop.matches) return;
        if (e.target.hasAttribute('data-filter-search')) return; /* non la ricerca interna */
        applyFilters();
      });
    }

    /* "Mostra altri prodotti": carica la pagina successiva e accoda i prodotti */
    var loadMoreBtn = document.getElementById('coll-load-more');
    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function() {
        var url = loadMoreBtn.dataset.nextUrl;
        if (!url) return;
        loadMoreBtn.classList.add('is-loading');
        fetch(url)
          .then(function(r) { return r.text(); })
          .then(function(html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newGrid = doc.getElementById('coll-grid');
            var grid = document.getElementById('coll-grid');
            if (newGrid && grid) {
              while (newGrid.firstElementChild) grid.appendChild(newGrid.firstElementChild);
            }
            var newBtn = doc.getElementById('coll-load-more');
            if (newBtn && newBtn.dataset.nextUrl) {
              loadMoreBtn.dataset.nextUrl = newBtn.dataset.nextUrl;
              loadMoreBtn.classList.remove('is-loading');
            } else {
              var box = loadMoreBtn.closest('.coll__loadmore');
              (box || loadMoreBtn).remove();
            }
            if (window.wishlistUpdate) window.wishlistUpdate();
          })
          .catch(function() { loadMoreBtn.classList.remove('is-loading'); });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  /* Precompila il form quando si arriva dal link "Ordina campione" della scheda
     prodotto: ?oggetto=campione&prodotto=...&sku=... */
  (function () {
    var params = new URLSearchParams(window.location.search);
    if (params.get('oggetto') !== 'campione') return;

    var prodotto = params.get('prodotto');
    if (!prodotto) return;
    var sku = params.get('sku');

    var body = document.getElementById('contact-body');
    if (body && !body.value.trim()) {
      body.value =
        'Buongiorno,\nvorrei richiedere un campione del seguente prodotto:\n\n' +
        prodotto + (sku ? ' (SKU: ' + sku + ')' : '') +
        '\n\nGrazie.';
    }

    /* seleziona l'oggetto piu pertinente fra quelli configurati, se presente */
    var subject = document.getElementById('contact-subject');
    if (subject) {
      for (var i = 0; i < subject.options.length; i++) {
        var label = subject.options[i].value.toLowerCase();
        if (label.indexOf('campion') !== -1 || label.indexOf('prodotto') !== -1) {
          subject.selectedIndex = i;
          break;
        }
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    /* === ELEMENTS === */
    var menuToggle = document.querySelector('.header__menu-toggle');
    var header = document.querySelector('.header');
    var drawer = document.getElementById('nav-drawer');
    var overlay = document.getElementById('nav-drawer-overlay');
    var closeBtn = drawer.querySelector('.nav-drawer__close');
    var drawerOpen = false;

    /* Portal the drawer + overlay out to <body>. The header wrapper gets a
       CSS transform on mobile (smart sticky), which would otherwise become the
       containing block for these position:fixed elements and clip/break them. */
    if (drawer && drawer.parentNode !== document.body) document.body.appendChild(drawer);
    if (overlay && overlay.parentNode !== document.body) document.body.appendChild(overlay);

    /* === DRAWER === */
    function openDrawer() {
      drawerOpen = true;
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      menuToggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      if (closeBtn) closeBtn.focus();
    }

    function closeDrawer() {
      drawerOpen = false;
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      menuToggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      drawer.querySelectorAll('.nav-drawer__panel.is-open').forEach(function(p) {
        p.classList.remove('is-open');
      });
      menuToggle.focus();
    }

    menuToggle.addEventListener('click', openDrawer);
    closeBtn.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);

    drawer.querySelectorAll('[data-open-panel]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var panel = document.getElementById('nav-drawer-panel-' + btn.getAttribute('data-open-panel'));
        if (panel) panel.classList.add('is-open');
      });
    });
    drawer.querySelectorAll('[data-close-panel]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var panel = document.getElementById('nav-drawer-panel-' + btn.getAttribute('data-close-panel'));
        if (panel) panel.classList.remove('is-open');
      });
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });

    /* === STICKY HEADER ===
       The whole header block sticks as one unit via CSS (.site-header-sticky),
       so it stays identical while scrolling. Here we only keep
       --header-visible-height in sync so sub-navigation (e.g. the collection
       filter bar) can offset itself right below the header. */
    var announcementEl = document.querySelector('.announcement-bar');
    var root = document.documentElement;

    function syncStaticHeights() {
      var annH = announcementEl ? announcementEl.offsetHeight : 0;
      root.style.setProperty('--announcement-height', annH + 'px');
    }

    /* --header-visible-height = the header's bottom edge, computed analytically
       (NOT from getBoundingClientRect) so it reflects the header's RESTING
       position and is not thrown off mid-animation by the smart-sticky transform.
       Sub-nav (the collection filter bar) uses it to sit right below the header.
       When the header is hidden on mobile, it becomes 0 so the filter bar pins
       to the very top instead of hiding behind the (offscreen) header. */
    function syncVisibleHeight() {
      if (!header) return;
      var isMobile = window.innerWidth < 768;
      if (isMobile && root.classList.contains('header-hidden')) {
        root.style.setProperty('--header-visible-height', '0px');
        return;
      }
      var y = window.pageYOffset || 0;
      var annH = announcementEl ? announcementEl.offsetHeight : 0;
      var bottom = header.offsetHeight + Math.max(0, annH - y);
      root.style.setProperty('--header-visible-height', bottom + 'px');
    }

    /* === SMART STICKY (MOBILE ONLY) ===
       Scrolling down hides the header, scrolling up brings it back.
       On desktop (>=768px) nothing hides — the CSS transform only applies on mobile. */
    var stickyWrap = document.querySelector('.site-header-sticky');
    var lastY = window.pageYOffset || 0;
    var SCROLL_THRESHOLD = 6; /* ignore jittery micro-scrolls */

    /* Hide/show the header with PURE-CSS transitions (no per-frame JS):
       - toggle .header-hidden on <html> → CSS slides .header up/down
       - set --header-visible-height to the resting target → the filter bar's
         `top` animates the SAME 0.16s ease-out (via .header-animating), so header
         and bar move in perfect lockstep with zero layout thrashing. */
    var animTimer = null;
    function setHidden(hide) {
      var was = root.classList.contains('header-hidden');
      if (was === hide) return;              /* no state change → nothing to animate */
      root.classList.add('header-animating');
      root.classList.toggle('header-hidden', hide);
      root.style.setProperty('--header-visible-height', (hide ? 0 : header.offsetHeight) + 'px');
      if (animTimer) clearTimeout(animTimer);
      animTimer = setTimeout(function() {
        root.classList.remove('header-animating');
        syncVisibleHeight();                 /* settle on the exact resting value */
      }, 180);
    }

    function updateSmartSticky() {
      if (!stickyWrap) return;
      var y = window.pageYOffset || 0;
      var isMobile = window.innerWidth < 768;
      /* Desktop, or drawer open: always fully visible */
      if (!isMobile || (drawer && drawer.classList.contains('is-open'))) {
        setHidden(false);
        lastY = y;
        return;
      }
      var headerH = header ? header.offsetHeight : 0;
      var annH = announcementEl ? announcementEl.offsetHeight : 0;
      var diff = y - lastY;
      if (Math.abs(diff) < SCROLL_THRESHOLD) return; /* keep lastY so small moves accumulate */
      if (y <= annH + headerH) {
        setHidden(false); /* near the top: always show */
      } else if (diff > 0) {
        setHidden(true);  /* scrolling down: hide */
      } else {
        setHidden(false); /* scrolling up: reveal */
      }
      lastY = y;
    }

    syncStaticHeights();
    syncVisibleHeight();

    var ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(function() { updateSmartSticky(); syncVisibleHeight(); ticking = false; });
        ticking = true;
      }
    }, { passive: true });
    window.addEventListener('resize', function() {
      syncStaticHeights(); syncVisibleHeight();
      /* leaving mobile width must clear any hidden state */
      if (window.innerWidth >= 768) { root.classList.remove('header-hidden', 'header-animating'); }
    });
    window.addEventListener('load', function() { syncStaticHeights(); syncVisibleHeight(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-address-toggle]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var form = document.getElementById('address-form-' + btn.getAttribute('data-address-toggle'));
        if (form) form.hidden = !form.hidden;
      });
    });

    /* Preselect the saved country + build the province select from data-provinces */
    function syncProvinces(countrySel) {
      var form = countrySel.closest('form');
      if (!form) return;
      var provField = form.querySelector('[data-address-province]');
      if (!provField) return;
      var opt = countrySel.options[countrySel.selectedIndex];
      var provinces = [];
      try { provinces = JSON.parse(opt.getAttribute('data-provinces') || '[]'); } catch (e) {}
      var current = provField.value || provField.dataset.default || '';

      if (provinces.length === 0) {
        /* country without provinces: plain text input */
        if (provField.tagName === 'SELECT') {
          var input = document.createElement('input');
          input.type = 'text'; input.name = provField.name; input.id = provField.id;
          input.setAttribute('data-address-province', ''); input.dataset.default = provField.dataset.default || '';
          provField.replaceWith(input);
        }
        return;
      }
      /* country with provinces: turn field into a select */
      var sel = provField;
      if (sel.tagName !== 'SELECT') {
        sel = document.createElement('select');
        sel.name = provField.name; sel.id = provField.id;
        sel.setAttribute('data-address-province', ''); sel.dataset.default = provField.dataset.default || '';
        provField.replaceWith(sel);
      }
      sel.innerHTML = '';
      provinces.forEach(function(p) {
        var o = document.createElement('option');
        o.value = p[0]; o.textContent = p[1];
        if (p[0] === current || p[1] === current) o.selected = true;
        sel.appendChild(o);
      });
    }

    document.querySelectorAll('select[data-address-country]').forEach(function(sel) {
      var def = sel.dataset.default;
      if (def) {
        for (var i = 0; i < sel.options.length; i++) {
          if (sel.options[i].value === def || sel.options[i].text === def) { sel.selectedIndex = i; break; }
        }
      }
      syncProvinces(sel);
      sel.addEventListener('change', function() { syncProvinces(sel); });
    });

    /* Delete confirmation (safe: no inline JS with translated strings) */
    document.querySelectorAll('[data-confirm]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        if (!window.confirm(btn.dataset.confirm)) e.preventDefault();
      });
    });

    /* If a form posted with errors, reopen it */
    document.querySelectorAll('.account__card[hidden]').forEach(function(card) {
      if (card.querySelector('.account__errors')) card.hidden = false;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
  (function() {
    /* Toggle between login and recover-password cards */
    var loginCard = document.getElementById('login-card');
    var recoverCard = document.getElementById('recover-card');
    var toRecover = document.getElementById('recover-toggle');
    var toLogin = document.getElementById('login-toggle');
    if (!loginCard || !recoverCard) return;

    function show(which) {
      var recover = which === 'recover';
      recoverCard.hidden = !recover;
      loginCard.hidden = recover;
    }
    if (toRecover) toRecover.addEventListener('click', function(e) { e.preventDefault(); show('recover'); location.hash = 'recover'; });
    if (toLogin) toLogin.addEventListener('click', function(e) { e.preventDefault(); show('login'); location.hash = 'login'; });

    /* Deep-link: #recover opens the recover form (also after a failed/success post) */
    var recoverMsg = recoverCard.querySelector('.account__success, .account__errors');
    if (location.hash === '#recover' || recoverMsg) {
      show('recover');
      if (recoverMsg) recoverMsg.focus();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
  (function() {
    var popup = document.getElementById('nl-popup');
    if (!popup) return;
    var KEY = 'comenido_nl_popup';
    var lastFocus;

    /* If the form was just submitted, show immediately and don't re-suppress */
    var justSubmitted = !!popup.querySelector('.nl-popup__success');

    function dismissed() {
      try {
        var t = parseInt(localStorage.getItem(KEY), 10);
        return t && (Date.now() - t) < 30 * 24 * 60 * 60 * 1000;
      } catch (e) { return false; }
    }
    function markDismissed() { try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {} }

    /* display inline oltre a [hidden]: la chiusura non deve dipendere dal CSS
       della sezione, che subito dopo una pubblicazione puo' essere in cache vecchia */
    function setVisible(v) {
      popup.hidden = !v;
      popup.style.display = v ? 'flex' : 'none';
    }

    setVisible(false);

    function open() {
      lastFocus = document.activeElement;
      setVisible(true);
      var input = popup.querySelector('input[type="email"]');
      if (input) input.focus();
      document.addEventListener('keydown', onKey);
    }
    function close() {
      setVisible(false);
      markDismissed();
      document.removeEventListener('keydown', onKey);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function onKey(e) { if (e.key === 'Escape') close(); }

    popup.querySelectorAll('[data-nl-close]').forEach(function(el) { el.addEventListener('click', close); });

    if (justSubmitted) { open(); return; }
    if (dismissed()) return;

    var delay = (parseInt(popup.dataset.delay, 10) || 0) * 1000;
    setTimeout(open, delay);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["privacy-banner"]) return;
  try {
    
  (function() {
    var banner = document.getElementById('cookie-banner');
    if (!banner) return;
    var accept = banner.querySelector('[data-cookie-accept]');
    var reject = banner.querySelector('[data-cookie-reject]');

    function api() { return window.Shopify && window.Shopify.customerPrivacy; }
    function show() { banner.hidden = false; }
    function hide() { banner.hidden = true; }

    function setConsent(value) {
      if (api() && typeof api().setTrackingConsent === 'function') {
        api().setTrackingConsent(
          { analytics: value, marketing: value, preferences: value, sale_of_data: value },
          hide
        );
      } else {
        try { localStorage.setItem('comenido_cookie_consent', value ? 'accepted' : 'rejected'); } catch (e) {}
      }
      hide();
    }

    function init() {
      if (api() && typeof api().shouldShowBanner === 'function') {
        if (api().shouldShowBanner()) show();
      } else {
        try { if (!localStorage.getItem('comenido_cookie_consent')) show(); } catch (e) { show(); }
      }
    }

    if (accept) accept.addEventListener('click', function() { setConsent(true); });
    if (reject) reject.addEventListener('click', function() { setConsent(false); });

    if (api()) { init(); }
    else {
      var tries = 0;
      var iv = setInterval(function() {
        tries++;
        if (api() || tries > 20) { clearInterval(iv); init(); }
      }, 200);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function() {
    /* === GALLERY (Brooklinen style) === */
    var track = document.getElementById('product-gallery');
    var thumbs = document.querySelectorAll('.product__gallery-thumb');
    var prevBtn = document.getElementById('gallery-prev');
    var nextBtn = document.getElementById('gallery-next');
    var slides = track ? track.querySelectorAll('.product__gallery-slide') : [];
    var totalSlides = slides.length;
    var currentSlide = 0;

    function goToSlide(i) {
      if (i < 0) i = 0;
      if (i >= totalSlides) i = totalSlides - 1;
      currentSlide = i;
      if (!slides[i]) return;
      if (window.innerWidth >= 768) {
        /* Desktop = Dalfilo grid (all images visible): scroll the page to the image */
        slides[i].scrollIntoView({ block: 'center', behavior: 'smooth' });
      } else {
        /* Mobile = swipe carousel */
        track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
      }
      thumbs.forEach(function(t, idx) { t.classList.toggle('is-active', idx === i); });
      var activeThumb = document.querySelector('.product__gallery-thumb.is-active');
      if (activeThumb) activeThumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function() { goToSlide(currentSlide - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { goToSlide(currentSlide + 1); });

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() { goToSlide(Number(thumb.dataset.slide)); });
    });

    /* Detect swipe position */
    var scrollTimer;
    if (track) track.addEventListener('scroll', function() {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function() {
        var closest = 0;
        var minDist = Infinity;
        slides.forEach(function(s, i) {
          var dist = Math.abs(s.offsetLeft - track.scrollLeft);
          if (dist < minDist) { minDist = dist; closest = i; }
        });
        if (closest !== currentSlide) {
          currentSlide = closest;
          thumbs.forEach(function(t, idx) { t.classList.toggle('is-active', idx === closest); });
        }
      }, 100);
    }, { passive: true });

    /* === M² / BOX CALCULATOR === */
    var inputMq = document.getElementById('user-mq');
    var inputBox = document.getElementById('user-box');
    var cartQty = document.getElementById('cart-quantity');
    var totalDisplay = document.getElementById('calc-total-price');

    if (inputMq && inputBox && cartQty) {
      var mqPerBox = parseFloat(inputMq.value) || 1;
      var form = document.getElementById('product-form');
      window.__productPricePerBox = parseInt(form.dataset.price || '0');
      var formatEuro = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' });

      function recalcFromMq() {
        var mq = parseFloat(inputMq.value) || 0;
        var boxes = Math.max(1, Math.ceil(mq / mqPerBox));
        inputBox.value = boxes;
        cartQty.value = boxes;
        updateTotal(boxes);
      }

      function recalcFromBox() {
        var boxes = Math.max(1, parseInt(inputBox.value) || 1);
        inputBox.value = boxes;
        var mq = (boxes * mqPerBox).toFixed(1);
        inputMq.value = mq;
        cartQty.value = boxes;
        updateTotal(boxes);
      }

      function updateTotal(boxes) {
        if (totalDisplay && window.__productPricePerBox) {
          var total = (window.__productPricePerBox * boxes) / 100;
          totalDisplay.textContent = formatEuro.format(total);
        }
      }

      inputMq.addEventListener('input', recalcFromMq);
      inputMq.addEventListener('change', function() {
        /* Snap to box boundary */
        var mq = parseFloat(inputMq.value) || 0;
        var boxes = Math.max(1, Math.ceil(mq / mqPerBox));
        inputMq.value = (boxes * mqPerBox).toFixed(1);
        inputBox.value = boxes;
        cartQty.value = boxes;
        updateTotal(boxes);
      });
      inputBox.addEventListener('input', recalcFromBox);

      /* +/- buttons */
      document.querySelectorAll('[data-calc-action]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var action = btn.dataset.calcAction;
          if (action === 'mq-minus') { inputMq.value = Math.max(mqPerBox, (parseFloat(inputMq.value) || mqPerBox) - mqPerBox).toFixed(1); recalcFromMq(); }
          if (action === 'mq-plus') { inputMq.value = ((parseFloat(inputMq.value) || 0) + mqPerBox).toFixed(1); recalcFromMq(); }
          if (action === 'box-minus') { inputBox.value = Math.max(1, (parseInt(inputBox.value) || 1) - 1); recalcFromBox(); }
          if (action === 'box-plus') { inputBox.value = (parseInt(inputBox.value) || 1) + 1; recalcFromBox(); }
          if (action === 'qty-minus') { var q = document.getElementById('simple-qty'); q.value = Math.max(1, (parseInt(q.value) || 1) - 1); }
          if (action === 'qty-plus') { var q = document.getElementById('simple-qty'); q.value = (parseInt(q.value) || 1) + 1; }
        });
      });

      recalcFromBox();
    }

    /* === TABS / ACCORDION === */
    /* Desktop tabs */
    document.querySelectorAll('.product__tab-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var tab = btn.dataset.tab;
        document.querySelectorAll('.product__tab-btn').forEach(function(b) { b.classList.remove('is-active'); });
        document.querySelectorAll('.product__tab-panel').forEach(function(p) { p.classList.remove('is-active'); });
        btn.classList.add('is-active');
        document.querySelector('[data-panel="' + tab + '"]').classList.add('is-active');
      });
    });

    /* Mobile accordion */
    document.querySelectorAll('.product__accordion-toggle').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var panel = btn.closest('.product__tab-panel');
        var wasActive = panel.classList.contains('is-active');
        /* Close all first on mobile */
        if (window.innerWidth < 768) {
          document.querySelectorAll('.product__tab-panel').forEach(function(p) { p.classList.remove('is-active'); });
          document.querySelectorAll('.product__accordion-toggle').forEach(function(b) { b.classList.remove('is-active'); });
        }
        if (!wasActive) {
          panel.classList.add('is-active');
          btn.classList.add('is-active');
        }
      });
    });

    /* === STICKY ADD TO CART (mobile) === */
    var stickyBar = document.getElementById('sticky-atc');
    var formArea = document.getElementById('product-form-area');
    var stickyBtn = document.getElementById('sticky-atc-btn');

    if (stickyBar && formArea) {
      function checkSticky() {
        if (window.innerWidth >= 768) {
          stickyBar.classList.remove('is-visible');
          return;
        }
        var rect = formArea.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) {
          stickyBar.classList.add('is-visible');
        } else {
          stickyBar.classList.remove('is-visible');
        }
      }

      window.addEventListener('scroll', checkSticky, { passive: true });
      window.addEventListener('resize', checkSticky);
      checkSticky();

      if (stickyBtn) {
        stickyBtn.addEventListener('click', function() {
          formArea.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }
    }

    /* === VARIANT SELECTOR === */
    var vForm = document.getElementById('product-form');
    var idInput = document.getElementById('variant-id');
    var variantDataEl = document.getElementById('variant-data');

    if (vForm && idInput && variantDataEl) {
      var variants = [];
      try { variants = JSON.parse(variantDataEl.textContent); } catch (e) { variants = []; }
      var rawMq = parseFloat(vForm.dataset.mq) || 0;
      var priceMainEl = document.querySelector('.product__price-main');
      var stickyPriceEl = document.getElementById('sticky-price');
      var buyBtn = document.querySelector('.product__btn-buy');
      var stickyBtnEl = document.getElementById('sticky-atc-btn');
      var availEl = document.querySelector('.product__availability');
      var euro = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' });

      /* "m²", or "m" for linear-metre goods. Read from the form: Liquid is inert here. */
      var unitLabel = vForm.dataset.unit || 'm²';
      /* Linear-metre goods are billed per pack, so they show the plain price. */
      var showsUnitPrice = rawMq > 0 && unitLabel !== 'm';

      function priceLabel(cents) {
        if (showsUnitPrice) return (cents / 100 / rawMq).toFixed(2).replace('.', ',') + ' €/' + unitLabel;
        return euro.format(cents / 100);
      }

      function selectedOptions() {
        var opts = [];
        document.querySelectorAll('.product__variant-group').forEach(function(group) {
          var checked = group.querySelector('input[type="radio"]:checked');
          if (checked) opts.push(checked.value);
        });
        return opts;
      }

      function findVariant(opts) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          if (v.options.length !== opts.length) continue;
          var match = true;
          for (var j = 0; j < opts.length; j++) {
            if (v.options[j] !== opts[j]) { match = false; break; }
          }
          if (match) return v;
        }
        return null;
      }

      function setUnavailable() {
        if (availEl) {
          availEl.className = 'product__availability product__availability--out';
          availEl.innerHTML = '<span>Non disponibile</span>';
        }
        if (buyBtn) buyBtn.disabled = true;
        if (stickyBtnEl) stickyBtnEl.disabled = true;
      }

      function updateComparePrice(v) {
        var compareEl = document.querySelector('.product__price-compare');
        if (!compareEl) return;
        if (v.compare_at_price && v.compare_at_price > v.price) {
          var compareLabel = priceLabel(v.compare_at_price);
          var pct = Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100);
          compareEl.innerHTML = '<s>' + compareLabel + '</s> <span class="product__price-discount">-' + pct + '%</span>';
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }

      function updateVariant() {
        /* refresh pill highlight */
        document.querySelectorAll('.product__variant-pill').forEach(function(pill) {
          var input = pill.querySelector('input');
          if (input) pill.classList.toggle('is-selected', input.checked);
        });

        var v = findVariant(selectedOptions());
        if (!v) { setUnavailable(); return; }

        idInput.value = v.id;
        vForm.dataset.price = v.price;
        window.__productPricePerBox = v.price;

        var label = priceLabel(v.price);
        if (priceMainEl) priceMainEl.textContent = (showsUnitPrice ? label.replace(' €/' + unitLabel, ' € / ' + unitLabel) : label);
        if (stickyPriceEl) stickyPriceEl.textContent = label;
        updateComparePrice(v);

        /* keep the wishlist button price in sync */
        var wishBtn = document.querySelector('.product__wishlist-btn');
        if (wishBtn) wishBtn.dataset.wishlistPrice = label;

        if (availEl) {
          /* stessa regola del badge Liquid: scorte a zero con vendita consentita
             (inventory_policy = "continue") NON e pronta consegna, e su ordinazione.
             Le etichette arrivano dai data-label-* perche in questo blocco il Liquid
             non viene interpretato: non si possono usare i filtri di traduzione. */
          var lbl = availEl.dataset;
          var tracked = v.inventory_management !== null && v.inventory_management !== undefined && v.inventory_management !== '';
          var isBackorder = v.available && tracked && v.inventory_quantity <= 0;
          var dot = '<span class="product__avail-dot"></span>';

          if (isBackorder) {
            availEl.className = 'product__availability product__availability--backorder';
            availEl.innerHTML = dot + '<span>' + (lbl.labelBackorder || 'Su ordinazione') + '</span>';
          } else if (v.available) {
            availEl.className = 'product__availability product__availability--in-stock';
            availEl.innerHTML = dot + '<span>' + (lbl.labelInStock || 'Disponibile') + '</span>';
          } else {
            availEl.className = 'product__availability product__availability--out';
            availEl.innerHTML = '<span>' + (lbl.labelOut || 'Non disponibile') + '</span>';
          }
        }
        if (buyBtn) buyBtn.disabled = !v.available;
        if (stickyBtnEl) stickyBtnEl.disabled = !v.available;

        /* switch gallery to the selected variant's image */
        if (v.featured_image && v.featured_image.id && typeof goToSlide === 'function') {
          var galleryTrack = document.getElementById('product-gallery');
          if (galleryTrack) {
            var slides = galleryTrack.querySelectorAll('.product__gallery-slide');
            for (var s = 0; s < slides.length; s++) {
              if (String(slides[s].getAttribute('data-media-id')) === String(v.featured_image.id)) {
                goToSlide(s);
                break;
              }
            }
          }
        }

        /* filter the gallery to show only the selected colour's images */
        if (window.__refreshColorFilter) window.__refreshColorFilter();

        /* notify quote form (resins) of the color change */
        var qColor = document.getElementById('quote-color');
        if (qColor) qColor.value = v.public_title || v.title || qColor.value;

        /* recompute calculator total, if present */
        var boxInput = document.getElementById('user-box') || document.getElementById('simple-qty');
        if (boxInput) boxInput.dispatchEvent(new Event('input', { bubbles: true }));

        /* reflect selection in URL for shareable links */
        if (window.history && window.history.replaceState) {
          try {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', v.id);
            window.history.replaceState({}, '', url);
          } catch (e) {}
        }
      }

      document.querySelectorAll('.product__variant-group input[type="radio"]').forEach(function(radio) {
        radio.addEventListener('change', updateVariant);
      });
    }
  })();

  /* === FULLSCREEN LIGHTBOX + VARIANT COLOUR FILTER === */
  (function() {
    var lb = document.getElementById('product-lightbox');
    if (!lb) return;
    /* Portal to <body> so its z-index isn't trapped under the header's stacking context */
    if (lb.parentNode !== document.body) document.body.appendChild(lb);
    var lbImg = document.getElementById('lb-img');
    var lbThumbs = document.getElementById('lb-thumbs');
    var thumbEls = lbThumbs ? lbThumbs.querySelectorAll('.product__lb-thumb') : [];
    var data = [];
    try { data = JSON.parse(document.getElementById('lightbox-data').textContent); } catch (e) {}
    var current = 0;

    function visibleIndexes() {
      var out = [];
      thumbEls.forEach(function(t) {
        if (!t.classList.contains('is-filtered')) out.push(Number(t.getAttribute('data-lb')));
      });
      return out;
    }
    function show(i) {
      if (i < 0 || i >= data.length) return;
      current = i;
      if (lbImg) { lbImg.src = data[i].url; lbImg.alt = data[i].alt || ''; }
      thumbEls.forEach(function(t) {
        var on = Number(t.getAttribute('data-lb')) === i;
        t.classList.toggle('is-active', on);
        if (on) t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      });
    }
    function step(dir) {
      var vis = visibleIndexes();
      if (!vis.length) return;
      var pos = vis.indexOf(current);
      if (pos === -1) { show(vis[0]); return; }
      show(vis[(pos + dir + vis.length) % vis.length]);
    }
    function open(i) {
      var vis = visibleIndexes();
      if (vis.indexOf(i) === -1 && vis.length) i = vis[0];
      show(i);
      lb.classList.add('is-open');
      lb.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('lb-open');
      document.body.classList.add('lb-open');
    }
    function close() {
      lb.classList.remove('is-open');
      lb.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('lb-open');
      document.body.classList.remove('lb-open');
    }

    document.querySelectorAll('.product__gallery-slide[data-index]').forEach(function(sl) {
      sl.addEventListener('click', function() { open(Number(sl.getAttribute('data-index'))); });
      sl.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(Number(sl.getAttribute('data-index'))); }
      });
    });
    thumbEls.forEach(function(t) {
      t.addEventListener('click', function() { show(Number(t.getAttribute('data-lb'))); });
    });
    var lbClose = document.getElementById('lb-close');
    var lbPrev = document.getElementById('lb-prev');
    var lbNext = document.getElementById('lb-next');
    if (lbClose) lbClose.addEventListener('click', close);
    if (lbPrev) lbPrev.addEventListener('click', function() { step(-1); });
    if (lbNext) lbNext.addEventListener('click', function() { step(1); });
    lb.addEventListener('click', function(e) { if (e.target === lb) close(); });
    document.addEventListener('keydown', function(e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') step(-1);
      else if (e.key === 'ArrowRight') step(1);
    });

    /* --- colour filter --- */
    function getSelectedColor() {
      var groups = document.querySelectorAll('.product__variant-group');
      for (var i = 0; i < groups.length; i++) {
        var lab = groups[i].querySelector('.product__variant-label');
        if (lab && /^(color|colore|colour)$/i.test(lab.textContent.trim())) {
          var ch = groups[i].querySelector('input:checked');
          return ch ? ch.value : '';
        }
      }
      return '';
    }
    window.__applyColorFilter = function(color) {
      color = (color || '').trim().toLowerCase();
      /* Does at least one image belong to the selected colour? */
      var anyMatch = false;
      if (color !== '') {
        document.querySelectorAll('.product__gallery-slide[data-color]').forEach(function(el) {
          if ((el.getAttribute('data-color') || '').trim().toLowerCase() === color) anyMatch = true;
        });
      }
      /* When the colour has its own image(s): show that colour + generic images
         (technical drawings, lifestyle) and hide the OTHER colours. Also hide the
         product's "hero" image if it's untagged — it's a colour photo that the
         selected colour's own image replaces (otherwise you'd see e.g. beige while
         "Pera" is selected). Generic non-hero images (measurements) stay visible.
         FALLBACK: colour has no tagged image → show everything (no data to filter). */
      function tog(el) {
        var c = (el.getAttribute('data-color') || '').trim().toLowerCase();
        var isFeatured = el.getAttribute('data-featured') === 'true';
        var hide = false;
        if (color !== '' && anyMatch) {
          if (c !== '' && c !== color) hide = true;      /* a different colour */
          else if (c === '' && isFeatured) hide = true;  /* untagged hero photo */
        }
        el.classList.toggle('is-filtered', hide);
        /* selected colour's photo first, generic images (measurements) after */
        if (el.style) {
          if (color !== '' && anyMatch) { el.style.order = (c === color) ? '0' : '1'; }
          else { el.style.order = ''; }
        }
      }
      document.querySelectorAll('.product__gallery-slide[data-color]').forEach(tog);
      document.querySelectorAll('.product__gallery-thumb[data-color]').forEach(tog);
      thumbEls.forEach(tog);
      /* if the lightbox is open on a now-hidden image, jump to first visible */
      if (lb.classList.contains('is-open')) {
        var vis = visibleIndexes();
        if (vis.indexOf(current) === -1 && vis.length) show(vis[0]);
      }
    };
    window.__refreshColorFilter = function() { window.__applyColorFilter(getSelectedColor()); };

    /* apply on load so only the default colour shows (if the product has colours) */
    window.__refreshColorFilter();
  })();

  /* === RESERVED PRICE: email-gated discount unlock === */
  (function() {
    var box = document.querySelector('.reserved-price--unlock');
    if (!box) return;
    var code = box.getAttribute('data-rp-code');
    var pct = parseFloat(box.getAttribute('data-rp-pct')) || 0;
    var head = box.querySelector('[data-rp-head]');
    var openBtn = box.querySelector('[data-rp-open]');
    var formWrap = box.querySelector('[data-rp-form]');
    var emailInput = box.querySelector('[data-rp-email]');
    var applyBtn = box.querySelector('[data-rp-apply]');
    var done = box.querySelector('[data-rp-done]');
    var key = 'rp_unlocked_' + code;

    /* Show the discounted price directly on the page (only after unlock — it is
       never published before). Scales the first number in the price by the %. */
    function applyDiscountedPrice() {
      var priceEl = document.querySelector('.product__price-main');
      if (!priceEl || priceEl.dataset.rpDone === '1') return;
      var txt = priceEl.textContent.replace(/\s+/g, ' ').trim();
      var m = txt.match(/\d[\d.]*,\d+|\d[\d.]*/);
      if (!m) return;
      var numStr = m[0];
      var num = parseFloat(numStr.replace(/\./g, '').replace(',', '.'));
      if (!num) return;
      var disc = num * (100 - pct) / 100;
      var discStr = disc.toFixed(2).replace('.', ',');
      var newTxt = txt.replace(numStr, discStr);
      priceEl.innerHTML = '<s class="product__price-was">' + txt + '</s> <span class="product__price-reserved">' + newTxt + '</span>';
      priceEl.dataset.rpDone = '1';
    }

    function showDone(updatePrice) {
      var y = window.pageYOffset;
      if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
      if (head) head.hidden = true;
      if (openBtn) openBtn.hidden = true;
      if (formWrap) formWrap.hidden = true;
      if (done) done.hidden = false;
      box.classList.add('is-unlocked');
      if (updatePrice !== false) applyDiscountedPrice();
      window.scrollTo(0, y);
    }

    /* already unlocked earlier in this browser */
    try { if (localStorage.getItem(key) === '1') showDone(); } catch (e) {}

    if (openBtn) openBtn.addEventListener('click', function() {
      openBtn.hidden = true;
      if (formWrap) formWrap.hidden = false;
      if (emailInput) { try { emailInput.focus({ preventScroll: true }); } catch (e) {} }
    });

    function unlock() {
      if (!emailInput) return;
      var email = emailInput.value.trim();
      if (!email || email.indexOf('@') === -1) { emailInput.focus({ preventScroll: true }); return; }
      if (applyBtn) { applyBtn.disabled = true; applyBtn.textContent = '…'; }
      /* 1) capture the email in Shopify (customer / newsletter) — pure fetch, no <form>, never navigates */
      var params = new URLSearchParams();
      params.append('form_type', 'customer');
      params.append('utf8', '✓');
      params.append('contact[tags]', 'sconto-riservato');
      params.append('contact[email]', email);
      fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
        credentials: 'same-origin'
      }).catch(function() {}).then(function() {
        /* 2) apply the discount code to the cart session in background (sets the discount cookie) */
        return fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function() {});
      }).then(function() {
        try { localStorage.setItem(key, '1'); } catch (e) {}
        /* Il carrello è già stato renderizzato: serve ricaricare perché
           i totali riflettano il codice appena applicato alla sessione. */
        window.location.reload();
      });
    }

    if (applyBtn) applyBtn.addEventListener('click', unlock);
    if (emailInput) emailInput.addEventListener('keydown', function(e) { if (e.key === 'Enter') { e.preventDefault(); unlock(); } });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"]) return;
  try {
    
  (function() {
    var KEY = 'comenido_recently_viewed';
    var MAX = 12;

    var esc = window.CN.esc;
    function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
    function write(list) { try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {} }

    /* Record current product */
    var currentEl = document.querySelector('[data-recently-current]');
    var currentHandle = null;
    if (currentEl) {
      try {
        var cur = JSON.parse(currentEl.textContent);
        currentHandle = cur.handle;
        var list = read().filter(function(i) { return i.handle !== cur.handle; });
        list.unshift(cur);
        write(list);
      } catch (e) {}
    }

    var grid = document.getElementById('recently-grid');
    var wrap = document.getElementById('recently-viewed');
    if (!grid || !wrap) return;

    var items = read().filter(function(i) { return i.handle !== currentHandle; });
    if (items.length === 0) return;

    var html = '';
    items.forEach(function(item) {
      var url = esc(item.url), title = esc(item.title), image = esc(item.image || ''), price = esc(item.price || '');
      html += '<a class="recently__card" href="' + url + '">';
      html += '<div class="recently__img-wrap">';
      html += image ? '<img class="recently__img" src="' + image + '" loading="lazy" alt="' + title + '">' : '';
      html += '</div>';
      html += '<span class="recently__name">' + title + '</span>';
      if (price) html += '<span class="recently__price">' + price + '</span>';
      html += '</a>';
    });
    grid.innerHTML = html;
    wrap.hidden = false;

    /* Arrows */
    var arrows = wrap.querySelectorAll('.recently__arrow');
    function updateArrows() {
      var maxScroll = grid.scrollWidth - grid.clientWidth - 2;
      arrows.forEach(function(a) {
        var dir = parseInt(a.dataset.dir, 10);
        a.disabled = dir < 0 ? grid.scrollLeft <= 2 : grid.scrollLeft >= maxScroll;
      });
    }
    arrows.forEach(function(a) {
      a.addEventListener('click', function() {
        grid.scrollBy({ left: parseInt(a.dataset.dir, 10) * grid.clientWidth * 0.8, behavior: 'smooth' });
      });
    });
    grid.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  (function() {
    var inner = document.querySelector('.related__inner[data-related-url]');
    if (!inner || inner.dataset.loaded) return;
    /* Already rendered server-side (recommendations request)? skip */
    if (inner.children.length > 0) { inner.dataset.loaded = '1'; return; }

    fetch(inner.dataset.relatedUrl)
      .then(function(r) { return r.text(); })
      .then(function(text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var fetched = doc.querySelector('.related__inner');
        if (fetched && fetched.children.length > 0) {
          inner.innerHTML = fetched.innerHTML;
        }
        inner.dataset.loaded = '1';
        if (window.wishlistUpdate) window.wishlistUpdate();
      })
      .catch(function() {});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  (function() {
    var trigger = document.getElementById('search-filter-trigger');
    var sidebar = document.getElementById('search-sidebar');
    var overlay = document.getElementById('search-filter-overlay');
    var closeBtn = document.getElementById('search-filter-close');
    if (!trigger || !sidebar) return;

    function open() { sidebar.classList.add('is-open'); overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function close() { sidebar.classList.remove('is-open'); overlay.classList.remove('is-open'); document.body.style.overflow = ''; }

    trigger.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (overlay) overlay.addEventListener('click', close);

    /* Toggle filter groups */
    document.querySelectorAll('[data-search-filter-toggle]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var content = btn.nextElementSibling;
        content.classList.toggle('is-open');
        btn.querySelector('svg').style.transform = content.classList.contains('is-open') ? 'rotate(180deg)' : '';
      });
    });

    /* Search within a filter group (long lists) */
    document.querySelectorAll('[data-search-filter-find]').forEach(function(input) {
      input.addEventListener('input', function() {
        var q = input.value.trim().toLowerCase();
        var content = input.closest('.search-page__filter-content');
        var list = content ? content.querySelector('.search-page__filter-list') : null;
        if (!list) return;
        list.querySelectorAll('li').forEach(function(li) {
          li.classList.toggle('is-hidden', q !== '' && (li.textContent || '').toLowerCase().indexOf(q) === -1);
        });
      });
      input.addEventListener('keydown', function(e) { if (e.key === 'Enter') e.preventDefault(); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust-badges"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var container = document.querySelector('.trust-badges__inner');
    var prevBtn = document.querySelector('.trust-badges__arrow--prev');
    var nextBtn = document.querySelector('.trust-badges__arrow--next');
    /* Guard: bundle is loaded on every page, section may be absent */
    if (!container || !prevBtn || !nextBtn) return;

    var items = container.querySelectorAll('.trust-badges__item');
    var current = 0;
    var total = items.length;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplayTimer = null;

    function isMobile() { return window.innerWidth < 768; }

    function goTo(index) {
      if (index < 0) index = total - 1;
      if (index >= total) index = 0;
      current = index;
      if (items[current]) {
        var offset = items[current].offsetLeft - container.offsetLeft;
        container.style.transform = 'translateX(-' + offset + 'px)';
      }
    }

    prevBtn.addEventListener('click', function() { stopAutoplay(); goTo(current - 1); });
    nextBtn.addEventListener('click', function() { stopAutoplay(); goTo(current + 1); });

    /* Auto-play on mobile only, disabled when user prefers reduced motion */
    function startAutoplay() {
      if (reduceMotion || autoplayTimer || !isMobile()) return;
      autoplayTimer = setInterval(function() { goTo(current + 1); }, 4000);
    }
    function stopAutoplay() {
      if (autoplayTimer) { clearInterval(autoplayTimer); autoplayTimer = null; }
    }
    startAutoplay();

    /* Reset on resize; run autoplay only on mobile */
    window.addEventListener('resize', function() {
      if (!isMobile()) {
        container.style.transform = '';
        current = 0;
        stopAutoplay();
      } else {
        goTo(current);
        startAutoplay();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
